import { insuranceIRR } from "../../engine/calculations";

const config = {
  key: "insurance-irr",
  title: "Insurance IRR",
  category: "Insurance & Protection",
  description: "See the actual annualised return (IRR) your traditional insurance policy delivers.",
  fields: [
    { key: "annualPremium", label: "Annual premium", type: "currency", default: 50_000, min: 500, max: 50_00_000 },
    { key: "premiumYears", label: "Premium paying years", type: "number", default: 15, min: 1, max: 40 },
    { key: "policyTerm", label: "Policy term (years)", type: "number", default: 20, min: 1, max: 50, help: "Total years until maturity — must be at least the premium paying years." },
    { key: "maturityValue", label: "Maturity value (incl. bonuses)", type: "currency", default: 15_00_000, min: 0, max: 10_00_00_000 },
  ],
  compute(values) {
    const annualPremium = Number(values.annualPremium) || 0;
    const premiumYears = Number(values.premiumYears) || 0;
    const policyTerm = Math.max(Number(values.policyTerm) || 0, premiumYears);
    const maturityValue = Number(values.maturityValue) || 0;

    const n = policyTerm + 1;
    const premiums = new Array(n).fill(0);
    const payouts = new Array(n).fill(0);
    const years = Array.from({ length: n }, (_, i) => i);
    for (let i = 0; i < premiumYears && i < n; i++) premiums[i] = annualPremium;
    payouts[policyTerm] = maturityValue;

    const rate = insuranceIRR(premiums, payouts, years);
    const totalPremiumsPaid = annualPremium * premiumYears;

    return {
      headline: { label: "Annualised return (IRR)", value: rate, format: "percent" },
      breakdown: [
        { label: "Total premiums paid", value: totalPremiumsPaid },
        { label: "Maturity value", value: maturityValue },
      ],
    };
  },
};

export default config;
